import React from 'react'
import { useSelector } from '~/store/hooks'

import { useStaticQuery, graphql } from 'gatsby'

const PhoneNumber = () => {
  const lang = useSelector((state) => state.lang)
  let globalSettings = null

  const datas = useStaticQuery(graphql`
    query {
      globalSettings: allContentfulGlobalSettings {
        nodes {
          title
          headerPhoneNumber
          headerPhoneNumberLabel
          node_locale
        }
      }
    }
  `)

  datas.globalSettings.nodes.forEach((item) => {
    if (item.node_locale === lang && item.title !== 'dummy content') {
      globalSettings = item
    }
  })

  return (
    <p className="flex items-center -ml-4 md:ml-0 md:pl-10">
      <span className="uppercase text-light-teal text-xs md:text-13 header__phone">
        <span className="block md:inline">
          {globalSettings?.headerPhoneNumberLabel}{' '}
        </span>
        <a href={`tel: ${globalSettings?.headerPhoneNumber}`} rel="nofollow">
          {globalSettings?.headerPhoneNumber}
        </a>
      </span>
    </p>
  )
}

export default PhoneNumber
